import React, { useState } from "react";
import PropTypes from "prop-types";

import { Tag, MoreButton } from "./styles";

const TagButtonList = ({ tags }) => {
    const [isMoreTagsOpen, setMoreTagsOpen] = useState(false);

    if (!tags || (Array.isArray(tags) && tags.length === 0)) {
        return null;
    }

    const tagDisplay = tags.map((tag, index) => {
        return (
            <Tag data-testid="tag" key={index} to={tag.url}>
                {tag.name}
            </Tag>
        );
    });

    if (tags.length > 49) {
        return (
            <>
                <div>
                    {tagDisplay.slice(0, 49)}
                    {isMoreTagsOpen && tagDisplay.slice(49)}
                </div>

                <MoreButton
                    data-testid="more-button"
                    type="button"
                    open={isMoreTagsOpen}
                    onClick={() => {
                        setMoreTagsOpen(!isMoreTagsOpen);
                    }}
                >
                    {isMoreTagsOpen ? "Show less" : "Show more"}
                </MoreButton>
            </>
        );
    }

    return <div>{tagDisplay}</div>;
};

TagButtonList.propTypes = {
    tags: PropTypes.array
};

const TagToggle = ({ tags }) => {
    return <TagButtonList tags={tags} />;
};

TagToggle.propTypes = {
    tags: PropTypes.array
};

export default TagToggle;

// animate the more/less section so it's less abrupt/startling to users with cognitive/mobile impairments;
// -- ^^ per robin, use "slide" example from https://archive-1_0_5.lightningdesignsystem.com/design/motion
